export enum PicklistRenderMode {
    LIST = 'LIST',
    DROPDOWN = 'DROPDOWN',
    CHECKBOX_LIST = 'CHECKBOX_LIST',
    AUTOCOMPLETE = 'AUTOCOMPLETE',
    REMOTE_AUTOCOMPLETE = 'REMOTE_AUTOCOMPLETE',
}
